import { NariaIcon, WidgetIcon } from "../../../assets/icons";
import React from "react";
import { CustomerInvoicesInfo } from "./CustomerInvoicesInfo";
import { CustomerT } from "../../../types";
import { formatMoney } from "../../../utils";
import Naira from "../../../assets/icons/Naira";
import { useTranslation } from "react-i18next";

interface CustomerInvoicesProps {
  customer: CustomerT;
  currency: string;
}
export const CustomerInvoices: React.FC<CustomerInvoicesProps> = ({
  customer, currency
}) => {
  const { t } = useTranslation("customer");
  return (
    <div className="flex gap-3 w-full mt-3 md:mt-0 md:w-full">
      <div className="w-full border rounded-md md:py-4 pb-4">
        <CustomerInvoicesInfo
          title={t("customer.totalBilled")}
          value={
            customer?.totalBilled ? formatMoney(customer?.totalBilled, currency) : formatMoney(0, currency)
          }
          color="active"
          icon={<Naira />}
        />
      </div>
      <div className="w-full border rounded-md md:py-4 pb-4">
        <CustomerInvoicesInfo
          title={t("customer.numInvoices")}
          value={customer?.totalInvoices ? `${customer?.totalInvoices}` : 0}
          color="secondary"
          icon={<WidgetIcon />}
        />
      </div>
    </div>
  );
};
